import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { Icon } from '../../../components/common'
import { getText } from '../../../internal/TextLabels'

import cssStyles from '../chat.module.scss'

export const ChatMini = ({ onClick, closed, disabled }) => {
  return (
    <div
      className={`${cssStyles.chatIconPosition} ${
        closed ? cssStyles.closed : ''
      }`}
    >
      <span
        className={cssStyles.helpText}
        onClick={!disabled ? onClick : null}
        role="presentation"
      >
        {closed ? getText('chat.closed') : getText('chat.help')}
      </span>
      <button
        type="button"
        className={`${cssStyles.expandButton} ${midas.button}`}
        onClick={!disabled ? onClick : null}
      >
        <Icon
          typeName="midasBubble2"
          additionalClassNames={cssStyles.chatBubbleIcon}
          style={{ color: 'white' }}
        />
      </button>
    </div>
  )
}

ChatMini.propTypes = {
  onClick: PropTypes.func.isRequired,
  closed: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
}
